"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Modal = require("react-modal");
var lodash_1 = require("lodash");
var DebtExtensionContent_1 = require("./components/DebtExtensionContent");
var DebtExtensionModal = /** @class */ (function (_super) {
    __extends(DebtExtensionModal, _super);
    function DebtExtensionModal() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.getStage1 = function () {
            var stage1 = (0, lodash_1.find)(_this.props.actions, ['action_type', 'stage_1']);
            if (stage1 !== undefined) {
                return stage1.created_at;
            }
            return null;
        };
        return _this;
    }
    DebtExtensionModal.prototype.render = function () {
        this.getStage1();
        return (React.createElement("div", null,
            React.createElement(Modal, { isOpen: this.props.showModal, portalClassName: "modal" },
                React.createElement(DebtExtensionContent_1.DebtExtensionContent, __assign({}, this.props, { minDate: this.getStage1() })))));
    };
    return DebtExtensionModal;
}(React.Component));
exports.default = DebtExtensionModal;
